import { render, staticRenderFns } from "./p03.vue?vue&type=template&id=1ab2dd30&scoped=true&"
import script from "./p03.vue?vue&type=script&lang=js&"
export * from "./p03.vue?vue&type=script&lang=js&"
import style0 from "./p03.vue?vue&type=style&index=0&id=1ab2dd30&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab2dd30",
  null
  
)

export default component.exports